import React from 'react';
import { RecordUsageRes } from '../../../redux/recordUsage/recordUsageApiSlice';

interface BarcodeInfoProps {
    barcodeInfo: RecordUsageRes | null;
}

const BarcodeInfo: React.FC<BarcodeInfoProps> = ({ barcodeInfo }) => {

    if (!barcodeInfo) return null;

    return (
        <div className='barcode-info-box'>
            <h5 className="box-title">Item Details</h5>
            <div className="barcode-info-container">
                <h5 className="barcode-title">
                    {barcodeInfo?.rxName ?? "-"}
                </h5>
                <div>
                    <label>Item Group</label>
                    <p>{barcodeInfo?.rxCategory ?? "-"}</p>
                </div>
                <div>
                    <label>NDC11</label>
                    <p>{barcodeInfo?.ndC11 ?? "-"}</p>
                </div>
                <div>
                    <label>Manufacturer</label>
                    <p>{barcodeInfo?.manufacturer ?? "-"}</p>
                </div>
                <div>
                    <label>Serial Number</label>
                    <p>NA</p>
                </div>
                <div>
                    <label>NDC/SKU</label>
                    <p>{barcodeInfo?.ndc ?? "-"}</p>
                </div>
                <div>
                    <label>User Def. 2</label>
                    <p>{barcodeInfo?.inventory ? barcodeInfo.inventory[0]?.item?.userDef1 || "-" : "-"}</p>
                </div>
                <div>
                    <label>LOT Number</label>
                    <p>{barcodeInfo?.lotNo ?? "-"}</p>
                </div>
                <div>
                    <label>Cost ($)</label>
                    <p>{barcodeInfo?.text3 ?? "-"}</p>
                </div>
                <div>
                    <label>Expiration Date</label>
                    <p>{barcodeInfo?.expDate ?? "-"}</p>
                </div>
                <div>
                    <label>Stock</label>
                    <p>{barcodeInfo?.list2 ?? "-"}</p>
                </div>
                <div>
                    <label>CVX/Model</label>
                    <p>{barcodeInfo?.cvx || "-"}</p>
                </div>
                <div>
                    <label>MVX Code</label>
                    <p>{barcodeInfo?.mvxCode ?? "-"}</p>
                </div>
                <div>
                    <label>MVX Manufacturer</label>
                    <p>{barcodeInfo?.mvxManufacturer ?? "-"}</p>
                </div>
                <div>
                    <label>Item Type</label>
                    <p>{barcodeInfo?.list1 ?? "-"}</p>
                </div>
            </div>
        </div>
    )
}

export default BarcodeInfo;
